






import { isNumber } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { CellClassParams } from '@ag-grid-community/all-modules'
import GridCellDecorationString from '@/components/kintai/atom/GridCellDecorationString.vue'

interface KintaiJikanCellClassParams extends CellClassParams {
  type: 'plain' | 'info' | 'danger'
  optionString?: string
}

@Component({
  components: { GridCellDecorationString }
})
export default class GridCellKoutsuhi extends Vue {
  private params!: KintaiJikanCellClassParams

  get hasGoukeiKingaku(): boolean {
    return this.params.value?.goukeiKingaku
  }

  get isTeiki(): boolean {
    return this.params.value?.teiki === '1'
  }

  get optionString(): string {
    return this.isTeiki ? '定期' : ''
  }

  get goukeikingaku(): string | undefined {
    if (!this.hasGoukeiKingaku) {
      return ''
    }

    if (this.isTeiki) {
      return ''
    }

    const goukeiKingaku = this.params.value.goukeiKingaku
    if (!isNumber(goukeiKingaku)) {
      return ''
    }
    return `¥${goukeiKingaku.toLocaleString()}`
  }
}
